import React from 'react';

export default function Divider() {
    return <div className="h_divider" />;
}
